import { useCallback, useEffect, useState } from 'react';
import { EPaletteModes, IModeImages, IThemeImages, ThemePack } from '@/types/theme-packs.types';
import Container from '@ui/container/container';
import ThemePackImageUpload from './theme-pack-image-upload';

type TThemePackImageChangeProps = {
  themePack?: ThemePack;
  onThemePackUpdate?: (pack: ThemePack) => void;
};

const Modes = Array.from(Object.values(EPaletteModes));

const getImageState = (themePack: ThemePack | undefined): IThemeImages | undefined => {
  return themePack?.images || {};
};

const ThemePackImageChange = ({ themePack, onThemePackUpdate }: TThemePackImageChangeProps) => {
  const [values, setValues] = useState(getImageState(themePack));

  const handleChange = useCallback(
    (mode: EPaletteModes, images: IModeImages) => {
      if (!themePack) {
        return;
      }

      setValues((prev) => ({
        ...prev,
        [mode]: images,
      }));

      onThemePackUpdate?.({
        ...themePack,
        images: {
          ...themePack.images,
          [mode]: images,
        },
      });
    },
    [onThemePackUpdate, themePack]
  );

  useEffect(() => {
    setValues(getImageState(themePack));
  }, [themePack]);

  if (!themePack) return null;

  return (
    <Container height="80px" width="100%" margin="0 auto" className="flex jc-center gap-16">
      {Modes.map((mode) => (
        <ThemePackImageUpload
          key={mode}
          mode={mode}
          onChange={(mode, images) => {
            handleChange(mode, images);
          }}
          modeImages={values?.[mode]}
        />
      ))}
    </Container>
  );
};

export default ThemePackImageChange;
